import React from 'react';
import { ChevronRight } from 'lucide-react';
import { useTranslation } from '../../i18n';
import MovementStoryCardCompact from './MovementStoryCardCompact';

/**
 * A horizontal, scroll-snapping row of compact Movement Story cards.
 * Mirrors the Growth Explore CategoryCarousel.
 */
export default function StoryCarousel({ title, stories, onOpen, onSeeAll }) {
  const { t } = useTranslation('movement');
  if (!stories || stories.length === 0) return null;

  return (
    <section className="ms-carousel-section" role="region" aria-label={title}>
      <div className="ms-carousel-header">
        <h2 className="ms-carousel-title">{title}</h2>
        {onSeeAll && stories.length >= 3 && (
          <button className="ms-carousel-see-all" onClick={onSeeAll}>
            {t('seeAll')} <ChevronRight size={14} />
          </button>
        )}
      </div>
      <div className="ms-carousel-track">
        {stories.map(s => (
          <MovementStoryCardCompact key={s.id} story={s} onOpen={onOpen} />
        ))}
      </div>
    </section>
  );
}
